import { render, staticRenderFns } from "./FinishVote.vue?vue&type=template&id=447bdf30&"
import script from "./FinishVote.vue?vue&type=script&lang=js&"
export * from "./FinishVote.vue?vue&type=script&lang=js&"
import style0 from "./FinishVote.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports